import { environment } from '../../../environments/environment';

const identityRoute = environment.identityRoute

export default identityRoute
